// Vérifie si un string est un JSON
function IsJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}


export { IsJsonString };
export default { IsJsonString };



// WEBPACK FOOTER //
// ./src/utils/json.js